import _omit from 'lodash/omit';
import _get from 'lodash/get';
import { Option, Values } from '@lib/interfaces/form';
import mergeAndUnlinkMultiSelectValues from '@lib/utils/mergeAndUnlinkMultiSelectValues';
import { SiteFieldNames } from '@lib/enums/fieldNames/siteFieldNames';

export default function getSiteAreaPreparedDataFromValues(
  values: Values,
  prevDocumentationLinks?: Option[],
) {
  const hasDocumentationLinksField =
    _get(values, SiteFieldNames.DocumentationLinks) !== undefined ||
    prevDocumentationLinks !== undefined;

  const base = _omit(
    values,
    'id',
    '__typename',
    'code',
    'fullCode',
    SiteFieldNames.DocumentationLinks,
  );

  if (!hasDocumentationLinksField) {
    return base;
  }

  const documentationLinksValues = (_get(
    values,
    SiteFieldNames.DocumentationLinks,
  ) || []) as Array<Option & { visibleViaQr?: boolean }>;
  const newDocLinks = documentationLinksValues.map(({ value, visibleViaQr }) =>
    visibleViaQr === undefined
      ? { id: `${value}` }
      : { id: `${value}`, visibleViaQr },
  );
  const prevDocLinks = (
    (prevDocumentationLinks || []) as Array<Option & { visibleViaQr?: boolean }>
  ).map(({ value, visibleViaQr }) =>
    visibleViaQr === undefined
      ? { id: `${value}` }
      : { id: `${value}`, visibleViaQr },
  );
  const documentationLinks =
    newDocLinks.length || prevDocLinks.length
      ? mergeAndUnlinkMultiSelectValues(prevDocLinks, newDocLinks)
      : undefined;

  return {
    ...base,
    documentationLinks,
  };
}
